var _defs, _path, _path2, _path3, _polygon, _path4, _g, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #343434;\n      }\n\n      .st2 {\n        fill: #faa527;\n      }\n\n      .st3 {\n        fill: #222;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251,19.9v-7.3s0-1.1-1.4-1.9-13.9-8-13.9-8c0,0-.5-.4-1.3-.4s-1.3.3-1.3.3l-22.4,13s-1.1.6-1.1,1.8v7.3l23.7-13.7s.5-.3,1.1-.3,1.1.3,1.1.3l15.5,8.9h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250,21l-14.7-8.4s-.2-.2-1-.2-1.3.5-1.3.5l-23.4,13.4v8.5l23.6-13.6s.5-.4,1.1-.4,1,.2,1,.2l15.6,8.9v-8.3l-1-.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251,31.3l-15.4-8.6s-.4-.3-1.2-.3-1.2.3-1.2.3l-23.6,13.6v8.5l25.3-7.9,16.2,7v-12.7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "234.8 37 209.4 50.7 209.4 37.2 234.8 25.8 234.8 37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.7,11.2l-1.5-.7c0,0-.1-.1-.1-.2v-1.1c.1-.1.3-.2.4-.1l1.5.7c0,0,.1.1.1.2v1.1c-.1.1-.3.2-.4.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.5,44.9v-8.5l23.6-13.6s.4-.3,1.2-.3.3,0,.4,0v-1.7h-.4c-.7,0-1.1.4-1.1.4l-23.6,13.6v-8.5l23.4-13.6s.5-.5,1.3-.5.3,0,.4,0v-1.6h-.3c-.6,0-1.1.3-1.1.3l-23.7,13.7v-7.3c0-1.2,1.1-1.8,1.1-1.8l22.5-13s.5-.3,1.3-.3.1,0,.2,0v-14.2L207.2-.5v51.1l27.6-13.6v-6.7l-25.2,14.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.2,2.5l-22.5,13s-1.1.6-1.1,1.8v7.3l23.7-13.7s.5-.3,1.1-.3.3,0,.3,0V2.2h-.2c-.8,0-1.3.3-1.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233,12.8l-23.4,13.5v8.5l23.6-13.6s.5-.4,1.1-.4.3,0,.4,0v-8.5h-.4c-.8,0-1.3.5-1.3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.2,22.8l-23.6,13.6v8.5l25.2-14.5v-7.9h-.4c-.8,0-1.2.3-1.2.3h0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250,21l-14.7-8.4s-.2-.2-1-.2-1.3.5-1.3.5l-23.4,13.4v2.2l23.6-13.6s.5-.4,1.1-.4,1,.2,1,.2l15.6,8.9v-1.9l-1-.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.7,24l-9.4-5.2s-.2-.2-1-.2-1.3.5-1.3.5l-23.4,13.4v2.2l23.6-13.6s.5-.4,1.1-.4,1,.2,1,.2l15.6,8.8v-2l-6.3-3.7Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.9,33.5c0-4.2,1.8-6.3,5.6-6.3h5.5c-.1-2-1.3-3.2-3-3.2s-2.5.9-2.8,2.2l-2.8-.9c.6-3.9,3.3-5.1,5.5-5.1,3.4,0,5.6,2.7,5.6,7.5v3.2h-8.1c-2,0-2.5.5-2.5,2.5v6h-3v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.9,34.1h1c3,0,4.4-1.2,4.4-4s-.1-1.6-.3-2.6l-.5-3.4,2.8-.4.4,2.4c.1.7.2,1.4.3,2h2.3v3l-.8.8h-1.6c-.6,3.7-3,6.1-7,6.1h-1v-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.5,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M86.2,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.9,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.6,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.4,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.1,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.8,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.5,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.2,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.9,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.6,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M113.3,28.8l.8-.8h1.7c3.8,0,5.8-.1,8.7-1.5l.9-.5h0c0-.1-4-1-4-1l-3.8-.9v1.9h-2.9v-1.9c0-2.4,1-3.5,3.1-3.5s1,.1,2.6.5l4.9,1.3c1.3.4,3,.6,4.5.6h.5v3.8h-1.8c0,.9.5,1.3,1.8,1.3h.8v3l-.8.8c-2.5,0-3.9-1.1-4.2-3.5h-.1c-4.4,3.1-6.9,3.5-10.1,3.5h-2.5v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.3,28.8l.8-.8h1.1c1.3,0,1.6-.5,1.6-1.5v-13.4h3v13.4c0,3.6-1.2,5.3-4.6,5.3h-1.9v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.8,13.1h3v18.7h-3V13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.9,34.1h1c3,0,4.4-1.2,4.4-4s-.1-1.6-.3-2.6l-.5-3.4,2.8-.4.4,2.4c.1.7.2,1.4.3,2h2.3v3l-.8.8h-1.6c-.6,3.7-3,6.1-7,6.1h-1v-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.5,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.2,28.8l.8-.8h2.7v3l-.8.8h-2.7v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.9,28.8l.8-.8h1.7c3.8,0,5.8-.1,8.7-1.5l.9-.5h0c0-.1-4-1-4-1l-3.8-.9v1.9h-2.9v-1.9c0-2.4,1-3.5,3.1-3.5s1,.1,2.6.5l4.9,1.3c1.3.4,3,.6,4.5.6h.5v3.8h-1.8c0,.9.5,1.3,1.8,1.3h.8v3l-.8.8c-2.5,0-3.9-1.1-4.2-3.5h-.1c-4.4,3.1-6.9,3.5-10.1,3.5h-2.5v-3ZM165.1,35.6c0-1.2.6-1.7,1.5-1.7h.5c.9,0,1.5.5,1.5,1.7s-.6,1.7-1.5,1.7h-.5c-.9,0-1.5-.5-1.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.9,28.8l.8-.8h.8c1.4,0,2-.6,2-1.8v-3.6h2.8v3.6c0,1.2.6,1.8,1.8,1.8h1v3l-.8.8c-2.7,0-4-1.1-4.5-3.4h-.2c-.5,2.4-1.5,3.4-3.7,3.4v-3ZM176.1,18.9c0-1.2.6-1.7,1.5-1.7h.5c.9,0,1.5.5,1.5,1.7s-.6,1.7-1.5,1.7h-.5c-.9,0-1.5-.5-1.5-1.7ZM180.1,18.9c0-1.2.6-1.7,1.5-1.7h.5c.9,0,1.5.5,1.5,1.7s-.6,1.7-1.5,1.7h-.5c-.9,0-1.5-.5-1.5-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187,30.4c-.8,1-1.9,1.4-3.7,1.4v-3l.8-.8c1.3,0,1.7-.3,2.1-1.3l.7-1.7c.9-2.1,2.2-3.9,4.6-3.9s4.8,2.7,4.8,7.1v.7l-2.4,3.6-6.8-2.1ZM188.3,26.9l5.1,1.5v-.3c0-2-1.1-3.2-2.7-3.2s-1.9.6-2.3,1.8v.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.020ac52431044fb06ea633a368f15168.svg";
export { ForwardRef as ReactComponent };